import { ChoiceButtonInput } from '@app/app/_components/Input/ChoiceButtonInput';
import { TransportPolicyValidity } from '@app/domain/model/eshop/transport/TransportPolicyValidity';
import { TransportPremiumsResponse } from '@app/domain/model/eshop/transport/TransportPremiumsResponse';
import { ChangeEvent } from 'react';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { Button } from '@app/app/_components/Button/Button';
import { Message } from '@app/app/_components/Message/Message';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { useTranslations } from 'next-intl';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';
import { useCascoOptions } from '@app/app/esales/transport/_sections/setups/useCascoOptions';

interface Props {
    policyValidity: Nullable<TransportPolicyValidity>;
    premiums: TransportPremiumsResponse[];
    setPremiums: (premiums: TransportPremiumsResponse[]) => void;
    insuranceDuration: string;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    value?: Nullable<string>;
    isCascoPresent?: boolean;
}

export function ChooseCascoStep({ premiums, insuranceDuration, onChange, value }: Props) {
    const t = useTranslations();
    const parameters = useAppParameters();

    const premiumOptions = useCascoOptions(premiums, insuranceDuration, parameters);

    return (
        <div className="flex flex-col gap-8">
            <ChoiceButtonInput
                name="insurancePackageCasco"
                options={premiumOptions}
                onChange={onChange}
                value={value ?? undefined}
            />
            <Message
                className="md:flex-row md:items-start"
                variant="info"
                addon={
                    <Button
                        href={parameters.eshopInfoUrls.comparePolicies}
                        preventDefault
                        variant="outlined"
                        size="tiny"
                        target="_blank"
                        rightAddon={<ArrowRightIcon className="size-4" />}>
                        {t('eshop.general.compare')}
                    </Button>
                }>
                <div className="flex flex-col gap-2">
                    <Paragraph isBold>{t('eshop.general.compareInsurances')}</Paragraph>
                    <Paragraph size="small">{t('eshop.transport.compareInsurancesMessage')}</Paragraph>
                </div>
            </Message>
        </div>
    );
}
